module.exports = __webpack_public_path__ + "img/no_messages.716a1a9f.png";